







































































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { Button, Toast } from 'vant';
import EXIF from 'exif-js';
import { FileType } from '@/common/ts/enum';
import { genHash, isWeiXin } from '@/common/ts/common';
import { getOssSignature } from '@/api/api';
import axios from 'axios';
Vue.use(Button).use(Toast);

const reader = new FileReader();
const imgCdnPrefix = 'https://image2.cqcb.com/';

interface IPresetFiles {
  cover: string;
  path: string;
}

@Component
export default class Uploader extends Vue {
  @Prop({ default: FileType.Image }) fileType!: FileType;
  @Prop({ default: () => [] }) presetFiles!: IPresetFiles[]; // 预设文件展示
  @Prop({ default: 9 }) maxImage!: number; // 默认可上传最多9张图片
  @Prop({ default: 1 }) maxVideo!: number; // 默认上传单个视频
  @Prop({ default: 100 }) videoMaxSize!: number; // 默认限制100MB视频上传限制
  @Prop({ default: 2 }) imageMaxSize!: number; // 默认限制10MB图片上传限制
  @Prop({ default: 1 }) imageMinSize!: number; // 默认限制10MB图片上传限制
  @Prop({ type: Function }) getOssSignatureFn!: any; // 自定义的oss签名函数
  @Prop({ type: String, default: '' }) customDir!: string;
  @Prop({ type: Boolean, default: false }) mustInApp!: boolean;
  @Prop({ type: Boolean, default: false }) compressFile!: boolean; // 是否需要压缩
  // data
  displayImages: string[] = [];
  readyToUploadQueue: any[] = [];
  FileType = FileType;
  showUploaderBtn = true;
  formData: any = [];
  isHaveLength = this.presetFiles && this.presetFiles.length !== 0;
  @Watch('presetFiles.length')
  onPresetFilesChange(val: any, oldval: any) {
    if (val !== oldval) {
      this.isHaveLength = this.presetFiles && this.presetFiles.length !== 0;
    }

    // 处理含预设上传图片时，剩余文件上传数量的控制
    if (
      (this.fileType === FileType.Image &&
        this.presetFiles.length >= this.maxImage) ||
      (this.fileType === FileType.Video &&
        this.presetFiles.length >= this.maxVideo)
    ) {
      this.showUploaderBtn = false;
    }
  }

  mounted() {
    // 处理含预设上传图片时，剩余文件上传数量的控制
    if (
      this.fileType === FileType.Image &&
      this.presetFiles.length >= this.maxImage
    ) {
      this.showUploaderBtn = false;
    } else if (
      this.fileType === FileType.Video &&
      this.presetFiles.length >= this.maxVideo
    ) {
      this.showUploaderBtn = false;
    } else {
      this.showUploaderBtn = true;
    }
  }

  // 上传阿里云
  public uploadToOss() {
    return new Promise((resolve, reject) => {
      // 客户端验证
      if (!this.mustInApp) {
        console.log('need not in app');
      } else if (!isWeiXin()) {
        return Toast('请在微信端参与');
      }
      if (!this.readyToUploadQueue.length && !this.isHaveLength) {
        return Toast('未选择上传作品');
      }
      Toast.loading({
        message: '作品上传中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      });
      Promise.all(
        this.readyToUploadQueue.map((item, index) => {
          return this.uploadOssWithSignature(item);
        }),
      )
        .then((result) => {
          // Toast.success('作品上传成功');
          // Toast.clear();
          const temp = this.presetFiles.map((item) => item.path);
          resolve([...temp, ...result]);
        })
        .catch((err) => {
          console.log(err);
          Toast.fail(`作品上传失败:${err.statusText}`);
          // Toast.clear();
        });
    });
  }

  @Watch('readyToUploadQueue')
  private onUploadImagesChange(newval: any[], oldval: any[]) {
    if (
      this.fileType === FileType.Image &&
      newval.length + this.presetFiles.length >= this.maxImage
    ) {
      this.showUploaderBtn = false;
    } else if (
      this.fileType === FileType.Video &&
      newval.length + this.presetFiles.length >= this.maxVideo
    ) {
      this.showUploaderBtn = false;
    } else {
      this.showUploaderBtn = true;
    }
  }

  // 获取图片base64Url
  private getImageFileLocalUrl(e: any) {
    const payloadFiles = e.target.files;
    if (payloadFiles[0].size / 1024 / 1024 > this.imageMaxSize) {
      return Toast(`上传图片文件限制${this.imageMaxSize}MB`);
    }
    if (payloadFiles[0].size / 1024 / 1024 < this.imageMinSize) {
      return Toast(`上传图片文件要求大于${this.imageMinSize}MB`);
    }
    const files: any[] = [];
    Object.keys(payloadFiles).forEach((key) => {
      files.push(payloadFiles[key]);
    });
    if (this.displayImages.length + files.length > this.maxImage) {
      return Toast('图片只能上传' + this.maxImage + '张');
    }
    let fileIndex = 0;
    if (!files.length) {
      return;
    }
    reader.readAsDataURL(files[fileIndex]);
    reader.onloadend = () => {
      if (!this.compressFile) {
        console.log('need compress');
        // ***** 图片是否需要压缩
        const data: any = {};
        data.file = this.dataURItoBlob(reader.result);
        data.name = payloadFiles[0].name;
        this.readyToUploadQueue = [...this.readyToUploadQueue, data];
        // ******
      }

      this.handelImageRotate(files[fileIndex], reader.result);
      fileIndex++;
      if (fileIndex < files.length) {
        reader.readAsDataURL(files[fileIndex]);
      }
    };
  }
  // base64转为 blob
  private dataURItoBlob(base64Data: any) {
    // console.log(base64Data); // data:image/png;base64,
    let byteString;
    if (base64Data.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(base64Data.split(',')[1]);
      // base64 解码
    } else {
      byteString = unescape(base64Data.split(',')[1]);
    }
    const mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]; // mime类型 -- image/png

    // const arrayBuffer = new ArrayBuffer(byteString.length); // 创建缓冲数组
    // const ia = new Uint8Array(arrayBuffer);// 创建视图
    const ia = new Uint8Array(byteString.length); // 创建视图
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ia], {
      type: mimeString,
    });
    return blob;
  }
  // 处理图片旋的情况
  private handelImageRotate(file: any, imgUrl: any) {
    const img = new Image();
    EXIF.getData(file, () => {
      const Orientation = EXIF.getTag(file, 'Orientation');
      img.src = imgUrl;
      img.onload = () => {
        // 缩放图片需要的canvas
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        const originWidth = img.width;
        const originHeight = img.height;
        // 最大尺寸限制
        const maxWidth = 1280;
        const maxHeight = 720;
        // 目标尺寸
        let targetWidth = originWidth;
        let targetHeight = originHeight;
        // 图片尺寸超过预设尺寸的限制时
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        // canvas对图片进行缩放
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // 清除画布
        if (!context) {
          return;
        }
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 具体处理各种画面旋转的情况
        if (Orientation && Orientation !== 1) {
          switch (Orientation) {
            case 6: // 旋转90度
              canvas.width = targetHeight;
              canvas.height = targetWidth;
              context.rotate(Math.PI / 2);
              // (0,-imgHeight) 从旋转原理图那里获得的起始点
              context.drawImage(
                img,
                0,
                -targetHeight,
                targetWidth,
                targetHeight,
              ); // 关键语句
              break;
            case 3: // 旋转180度
              context.rotate(Math.PI);
              context.drawImage(
                img,
                -targetWidth,
                -targetHeight,
                targetWidth,
                targetHeight,
              );
              break;
            case 8: // 旋转-90度
              canvas.width = targetHeight;
              canvas.height = targetWidth;
              context.rotate((3 * Math.PI) / 2);
              context.drawImage(
                img,
                -targetWidth,
                0,
                targetWidth,
                targetHeight,
              );
              break;
          }
        } else {
          context.drawImage(img, 0, 0, targetWidth, targetHeight);
        }
        // canvas转 base64
        this.displayImages.push(canvas.toDataURL('image/*', 0.8));
        // 控制上传图片数量
        if (this.displayImages.length >= this.maxImage) {
          this.showUploaderBtn = false;
        }
        // canvas转 blob用于 oss 上传
        canvas.toBlob((blob) => {
          const fileName = file.name;
          const blobFile: any = {};
          blobFile.name = fileName;
          blobFile.file = blob;
          if (this.compressFile) {
            console.log('not need compress');
            this.readyToUploadQueue = [...this.readyToUploadQueue, blobFile];
          }
        });
      };
    });
  }
  // 获取视频文件信息
  private getVideoFileInfo(e: any) {
    if (!e.target.files.length) {
      return;
    }
    const videoReader = new FileReader();
    const videoFile = e.target.files[0];
    videoReader.readAsArrayBuffer(videoFile);

    videoReader.onloadend = (x: any) => {
      // 判断视频是否超过指定大小
      const videoSize = Math.round(videoFile.size / 1024 / 1024);
      if (videoSize > this.videoMaxSize) {
        return Toast(`上传视频文件限制${this.videoMaxSize}MB`);
      }
      const blob = new Blob([new Uint8Array(x.currentTarget.result)], {
        type: videoFile.type,
      });
      this.readyToUploadQueue.push({
        file: blob,
        name: videoFile.name,
      });
      this.displayImages.push(require('@/assets/video.png'));
    };

    return;
  }

  // 移除所选图片
  private removeImage(index: number, type: 'added' | 'preset') {
    if (type === 'added') {
      this.displayImages.splice(index, 1);
      this.readyToUploadQueue.splice(index, 1);
      // (this.$refs.inputImage as HTMLInputElement).value = '';

      if (this.fileType === FileType.Image) {
        if (this.showUploaderBtn) {
          (this.$refs.inputImage as HTMLInputElement).value = '';
        }
      } else {
        if (this.showUploaderBtn) {
          (this.$refs.inputVideo as HTMLInputElement).value = '';
        }
      }
    } else if (this.presetFiles.length && type === 'preset') {
      if (this.fileType === FileType.Image) {
        // (this.$refs.inputImage as HTMLInputElement).value = '';
      } else {
        // (this.$refs.inputVideo as HTMLInputElement).value = '';
      }
      this.presetFiles.splice(index, 1);
    }
    this.showUploaderBtn = true;
  }

  private async uploadOssWithSignature(fileData: any) {
    return new Promise(async (resolve, reject) => {
      // 获取签名
      let res;
      if (typeof this.getOssSignatureFn === 'function') {
        res = await this.getOssSignatureFn();
      } else {
        res = await getOssSignature();
      }
      // const res = await getOssSignature();
      if (!res) {
        console.log('illegal hostname, this service is only fo cqcb.com');
        return;
      }
      const formData = new FormData();
      const fileTypeArr = fileData.name.split('.');
      const type = fileTypeArr[fileTypeArr.length - 1];
      // 上传的文件命名
      const fileName = `${(res as any).dir}${
        this.customDir
      }${genHash()}-${Date.now()}.${type}`.replace('&', '');

      formData.append('key', fileName);
      formData.append('policy', (res as any).policy);
      formData.append('OSSAccessKeyId', (res as any).accessid);
      formData.append('success_action_status', '200');
      formData.append('callback', (res as any).callback);
      formData.append('signature', (res as any).signature);

      formData.append('name', fileData.name); // 文件名
      formData.append('file', fileData.file); // 文件，选择时存在data上(图片和视频的文件对象区别对待)
      this.formData = formData; // 将formData对象存入data中，方便后续使用

      const ret = await axios.request({
        url: (res as any).host,
        data: formData,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (Number(ret.data.Status) === 200) {
        resolve(imgCdnPrefix + decodeURIComponent(ret.data.body));
      } else {
        reject('fail');
      }
    });
  }
}
